import { PropsWithChildren } from 'react';

import { OpenItemDialogLink } from 'components/link/OpenItemDialogLink';
import { ConversionCreditWithAmounts } from 'hooks/useConversionCredits';
import { isType } from 'lib/gql';

export const ConversionCreditPurchaseLink = ({
  purchase,
  children,
}: PropsWithChildren<{
  purchase: ConversionCreditWithAmounts['purchase'];
}>) => {
  if (!purchase) return children;

  if (purchase.anyCards.length > 1 && isType(purchase, 'TokenAuction')) {
    return (
      <OpenItemDialogLink item={purchase} sport={purchase.anyCards[0].sport}>
        {children}
      </OpenItemDialogLink>
    );
  }

  return (
    <OpenItemDialogLink
      item={purchase.anyCards[0]}
      sport={purchase.anyCards[0].sport}
    >
      {children}
    </OpenItemDialogLink>
  );
};
